var map = {
	"./Auth/Login": 76,
	"./Auth/Login.vue": 76,
	"./Auth/LoginBanner": 4747,
	"./Auth/LoginBanner.vue": 4747,
	"./Auth/Register": 7591,
	"./Auth/Register.vue": 7591,
	"./Categories/Index": 5948,
	"./Categories/Index.vue": 5948,
	"./Customers/Index": 8114,
	"./Customers/Index.vue": 8114,
	"./Customers/components/CreateChannelDialog": 8358,
	"./Customers/components/CreateChannelDialog.vue": 8358,
	"./Customers/components/CustomerChannels": 7249,
	"./Customers/components/CustomerChannels.vue": 7249,
	"./Customers/components/DeleteChannelDialog": 4494,
	"./Customers/components/DeleteChannelDialog.vue": 4494,
	"./Dashboard/Index": 5634,
	"./Dashboard/Index.vue": 5634,
	"./Error": 6955,
	"./Error.vue": 6955,
	"./Meta/Index": 4247,
	"./Meta/Index.vue": 4247,
	"./Orders/Components/DropIt": 9311,
	"./Orders/Components/DropIt.vue": 9311,
	"./Orders/Components/ImageCard": 5875,
	"./Orders/Components/ImageCard.vue": 5875,
	"./Orders/Icons/telegram": 9973,
	"./Orders/Icons/telegram.vue": 9973,
	"./Orders/Icons/viber": 6430,
	"./Orders/Icons/viber.vue": 6430,
	"./Orders/Icons/whatsapp": 484,
	"./Orders/Icons/whatsapp.vue": 484,
	"./Orders/Index": 6423,
	"./Orders/Index.vue": 6423,
	"./Orders/View": 7105,
	"./Orders/View.vue": 7105,
	"./Profile/Index": 3622,
	"./Profile/Index.vue": 3622,
	"./Profile/NotificationGroups": 497,
	"./Profile/NotificationGroups.vue": 497,
	"./Profile/Roles": 9620,
	"./Profile/Roles.vue": 9620,
	"./Settings/Components/ApprovalLog": 3536,
	"./Settings/Components/ApprovalLog.vue": 3536,
	"./Settings/LoginApprovals": 401,
	"./Settings/LoginApprovals.vue": 401,
	"./Users/Index": 3557,
	"./Users/Index.vue": 3557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;